/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/* prettier-ignore-start */
import React from "react";
import { classNames } from "@plasmicapp/react-web";

export type Guides4IconProps = React.ComponentProps<"svg"> & {
  title?: string;
};

export function Guides4Icon(props: Guides4IconProps) {
  const { className, style, title, ...restProps } = props;
  return (
    <svg
      xmlns={"http://www.w3.org/2000/svg"}
      fill={"none"}
      viewBox={"0 0 160 160"}
      height={"1em"}
      className={classNames("plasmic-default__svg", className)}
      style={style}
      {...restProps}
    >
      {title && <title>{title}</title>}

      <path
        stroke={"currentColor"}
        strokeOpacity={".2"}
        d={
          "M148.782 40.288v79.423L80 159.423l-68.782-39.712V40.288L80 .576zM80.5.541V160M11.061 39.567l138.378 80m-138.337-.541 137.837-79.459"
        }
      ></path>
    </svg>
  );
}

export default Guides4Icon;
/* prettier-ignore-end */
